import BasicMainLayoutSkin from "./basic/skins";

export { BasicMainLayoutSkin };

export const MAIN_LAYOUT_SKIN_REGISTRY = {
  basic: BasicMainLayoutSkin,
};

export function resolveMainLayoutSkin(code) {
  return MAIN_LAYOUT_SKIN_REGISTRY[code] || BasicMainLayoutSkin;
}
